import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

export const AUDIT_ACTIONS = {
  ORDER_MARK_PAID: 'order_mark_paid',
  ORDER_MARK_SHIPPED: 'order_mark_shipped',
  ORDER_MARK_CONFIRMED: 'order_mark_confirmed',
  ORDER_MARK_CANCELLED: 'order_mark_cancelled',
  ORDER_MARK_DELIVERED: 'order_mark_delivered',
  ORDER_ASSIGN_SHIPPING: 'order_assign_shipping',
  ORDER_DELETE: 'order_delete'
};

function safeString(value) {
  return typeof value === 'string' ? value : '';
}

export function buildAuditActor({ user, role, userData } = {}) {
  const email = safeString(user?.email);
  const displayName = safeString(user?.displayName);
  const profileName = safeString(userData?.name || userData?.fullName || userData?.username);

  return {
    uid: safeString(user?.uid),
    email,
    name: profileName || displayName || email,
    role: safeString(role)
  };
}

/**
 * Writes an immutable audit log entry.
 * This should NEVER throw in a way that breaks the main admin action.
 */
export async function logAuditEvent({
  action,
  targetType,
  targetId,
  targetLabel,
  details,
  actor
} = {}) {
  try {
    const actorSnapshot = actor || {};

    const payload = {
      action: safeString(action),
      targetType: safeString(targetType),
      targetId: safeString(targetId),
      targetLabel: safeString(targetLabel),
      details: details && typeof details === 'object' ? details : null,

      actorUid: safeString(actorSnapshot.uid),
      actorEmail: safeString(actorSnapshot.email),
      actorName: safeString(actorSnapshot.name),
      actorRole: safeString(actorSnapshot.role),

      createdAt: serverTimestamp(),
      createdAtIso: new Date().toISOString()
    };

    const ref = await addDoc(collection(db, 'auditLogs'), payload);
    return ref.id;
  } catch (e) {
    // Do not crash the admin flow if audit logging fails.
    console.warn('Audit log write failed:', e);
    return null;
  }
}
